define('ItemBadges.View', [
    'Backbone',
    'Backbone.CollectionView',
    'ItemBadges.BadgesList.View',
    'itembadges_view.tpl'
], function ItemBadgesView(
    Backbone,
    BackboneCollectionView,
    ItemBadgesbadgesListView,
    itembadgesViewTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: itembadgesViewTpl,

        contextDataRequest: ['item'],

        initialize: function initialize(options) {
            this.items = options.items;
            this.collection = options.collection;
            this.view = options.view;

            this.listenToOnce(this.collection, 'sync', this.render);
        },

        getContext: function getContext() {
            var itemBadges;
            var item;
            switch (this.view) {
            case 'pdp':
                itemBadges = this.items.item.custitem_ef_badges;
                break;
            default:
                item = this.contextData.item();
                itemBadges = item.custitem_ef_badges;
            }

            this.badgeCollection = this.collection ? this.collection.filterBadges(itemBadges || false) : [];

            return {
                hasBadges: !!this.badgeCollection
            };
        },

        childViews: {
            'Itembadges.List.View': function ItembadgesLisView() {
                return new BackboneCollectionView({
                    collection: this.badgeCollection,
                    childView: ItemBadgesbadgesListView,
                    childViewOptions: {
                        currentView: this.view
                    }
                });
            }
        }
    });
});
